export default {
  isLogin: false,
  menuUrl: '/',
  userMsg: {},
  isHandleMsg: false,
  isModifyUserPhoto: false,
  conditionForQuery: '',
  isShowNews: sessionStorage.getItem('isShowNews') || false,
  language: 'zh_CN',
}
